const { hasOwnProperty } = Object.prototype;
export function hasOwn(obj, property) {
  return hasOwnProperty.call(obj, property);
}

const RE_KEY_PATH = /(\.\.\/?)?(([^/]*)(?:\/(.*))?)?/;
export function splitKey(key) {
  return RE_KEY_PATH.exec(key);
}

let ID = (new Date()).getTime();
export function uniqueKey() {
  return (ID++).toString(36);
}
